<div class="container-fluid tp-box" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="card">
			<div class="card-header card-header-info card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(false, '')">
					<i class="material-icons">wb_cloudy</i>
				</div>
				<h3 class="card-title">Over Due Vendors {{ title }}</h3>
			</div>
			<div class="card-body" *ngIf="viewing">
				<ng-container *ngIf="!sending">
					<button class="btn btn-success" (click)="exportXls();"><i class="fa fa-file-excel-o"></i></button>
					&nbsp;&nbsp;
					<button class="btn btn-danger" (click)="exportPdf();"><i class="fa fa-file-pdf-o"></i></button>
				</ng-container>
				<ng-container *ngIf="sending">
					<svg class="spinner" width="30px" height="30px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
					</svg>
				</ng-container>
				<div class="table" #print_table>
					<table class="table">
						<tr>
							<th>Vendor</th>
							<th>Name</th>
							<th>Terms</th>
							<th>Bal</th>
							<th>30 Day</th>
							<th>60 Day</th>
							<th>90 Day</th>
						</tr>
						<tr *ngFor="let v of viewing">
							<td>{{ v.supplierid }}</td>
							<td>{{ v.suppname }}</td>
							<td>{{ v.terms }}</td>
							<td>{{ v.balance | currency }}</td>
							<td>{{ v.due | currency }}</td>
							<td>{{ v.overdue1 | currency }}</td>
							<td>{{ v.overdue2 | currency }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-info card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(original_aged, 'All')">
					<i class="material-icons">wb_cloudy</i>
				</div>
				<p class="card-category">Over Due Vendors</p>
				<h3 class="card-title">
					<span *ngIf="aged">
						{{ total_overdue_details.total }}
					</span>
					<span *ngIf="!aged">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
				</h3>
			</div>
			<small>
				<p class="card-category text-info text-justify mt-3 text-right">
					<span class="ml-1 mr-1 pointer" (click)="toggleFlip(aged30, '30 Days')"> ( {{ total_overdue_details.thirty }} ) 30 Day </span>
					<span class="ml-1 mr-1 pointer" (click)="toggleFlip(aged60, '60 Days')"> ( {{ total_overdue_details.sixty }} ) 60 Day </span>
					<span class="ml-1 mr-1 pointer" (click)="toggleFlip(aged90, '90 Days')"> ( {{ total_overdue_details.ninety }} ) 90 Day </span>
				</p>
			</small>
			<div class="card-footer">
				<div class="stats pointer">
					<a (click)="toggleFlip(original_aged, 'All')">
						<i class="material-icons">content_copy</i>
						View Now</a>
				</div>
				<br />
			</div>
		</div>
	</div>
</div>
